import { IBrand } from "@faire/web-api/indigofair/data/IBrand";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { faireBaseUrl } from "@faire/web/common/routes/faireBaseUrl";
import { PageLoader } from "@faire/web/ui/CircleSpinner";
import React from "react";

import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { FaireDirectLandingPage } from "@faire/retailer/views/faire-direct/FaireDirectLandingPage";

export const FaireDirectLandingPageRoot = () => {
  const {
    isFaireDirectActiveInLoggedOut,
    faireDirectBrandToken,
    faireDirectBrand,
  } = useFaireDirectBrand();

  if (!isFaireDirectActiveInLoggedOut) {
    getLocationOrThrow().replace(faireBaseUrl());
    return null;
  }

  return (
    <>
      {!faireDirectBrand ? (
        <PageLoader />
      ) : (
        <CurrentFaireDirectLandingPage
          faireDirectBrandToken={faireDirectBrandToken}
          faireDirectBrand={faireDirectBrand}
        />
      )}
    </>
  );
};

const CurrentFaireDirectLandingPage: React.FC<{
  faireDirectBrandToken: string;
  faireDirectBrand: IBrand;
}> = ({ faireDirectBrandToken, faireDirectBrand }) => {
  return (
    <FaireDirectLandingPage
      faireDirectBrandToken={faireDirectBrandToken}
      faireDirectBrand={faireDirectBrand}
    />
  );
};
